var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrintIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "print_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.312,
    height: 19.312,
    viewBox: "0 0 19.312 19.312",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_10892",
    "data-name": "Path 10892",
    d: "M0,0H19.312V19.312H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10893",
    "data-name": "Path 10893",
    d: "M15.679,7.023h-.8V3H5.219V7.023h-.8A2.411,2.411,0,0,0,2,9.437v4.828H5.219v3.219h9.656V14.265h3.219V9.437A2.411,2.411,0,0,0,15.679,7.023ZM6.828,4.609h6.437V7.023H6.828Zm6.437,9.656v1.609H6.828V12.656h6.437Zm1.609-1.609V11.047H5.219v1.609H3.609V9.437a.807.807,0,0,1,.8-.8H15.679a.807.807,0,0,1,.8.8v3.219Z",
    transform: "translate(-0.391 -0.586)",
    fill: "#4eb6ee"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_743",
    "data-name": "Ellipse 743",
    cx: 0.805,
    cy: 0.805,
    r: 0.805,
    transform: "translate(13.679 8.449)",
    fill: "#4eb6ee"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintIcon);
export default __webpack_public_path__ + "static/media/print_icon.18f0c1dbbe8de243322d27cbebbe5ff0.svg";
export { ForwardRef as ReactComponent };